import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Request from "../../../utils/Request";
import Config from "../../../utils/config";
import iconNotification from "../../../assets/images/icon-Notification.png";
import iconAnnouncement from "../../../assets/images/icon-Megaphone.png";
import IconLogout from "../../../assets/images/IconLogout";
import { Box, Icon, Text, ButtonOutline } from "../../styledConstants";
import { Announcement, ButtonLogout, UserInfo, Wrapper } from "./style";
import { getUser, isEmpty, userLogout } from "../../../utils/common";
import { getUserProfileDetaile } from "../../../utils/api";
import { getUserProfile } from "../../../store/actions/user";

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (isEmpty(user)) {
      dispatch(getUserProfile());
    }
  }, []);

  // const logout = () => {
  //   userLogout();
  //   navigate("/");
  // };

  // const adminProfile = (() => {
  //   navigate("/adminprofile");
  // })

  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <Wrapper className="flex  space-between header">
      <div>
        {currentPath !== "/dashboard" && currentPath !== "/welcome" && (
          <ButtonOutline className="flex flex-center" rg primary onClick={() => navigate(-1)}>
            BACK
          </ButtonOutline>
        )}
      </div>
      <div className="icon-container">
        <span>
          <Icon src={iconNotification} width="18px" alt="notification" />
        </span>
        <span>
          <Icon src={iconAnnouncement} width="18px" alt="accouncement" />
        </span>
      </div>

      {/*<Announcement className="flex flex-center">
        <Icon src={iconAnnouncement} width="23px" alt="" />
        <Text size="rg" fw="md">
          Announcement
        </Text>
        <Box width="24px" height="24px" bgColor="#F01102" className="flex flex-center justify-center count">
          3
        </Box>
      </Announcement> */}
      {/* <UserInfo className="flex flex-center pointer" onClick={adminProfile}>
        <Text className="short-name flex flex-center justify-center" size="rg" fw="md" color="color7">
         { (user && user.profileImage) ? <img  src={user.profileImage} alt="" className="profile-pic"/> :
          user && Object.keys(user).length
            ? user.firstName
              ? (user.firstName[0] + user.lastName[0]).toUpperCase()
              : ""
            : ""
          }
        </Text>
        <Text className="ml8 mr12" size="rg" fw="md">
          {user && user.firstName}
        </Text>
      </UserInfo>
      <ButtonSolid primary rg className="flex flex-center justify-center btn-logout" onClick={logout}>
        <IconLogout className="mr8" />
        Log out
      </ButtonSolid> */}
    </Wrapper>
  );
}
